import { render, staticRenderFns } from "./SeguimientoCese.vue?vue&type=template&id=06604b71&scoped=true&"
import script from "./SeguimientoCese.vue?vue&type=script&lang=js&"
export * from "./SeguimientoCese.vue?vue&type=script&lang=js&"
import style0 from "./SeguimientoCese.vue?vue&type=style&index=0&id=06604b71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06604b71",
  null
  
)

export default component.exports